import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getModuleData } from '../../../../selectors/modules';
import { Props } from './BadgesSpotlight';

type StateProps = Pick<Props, 'badges'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  return {
    badges: moduleData.badges,
  };
};

export default connect(mapStateToProps);
